
import { createSlice } from "@reduxjs/toolkit";
import { convertPermissionToObject } from "src/utils/helper";

interface IUser {
  userName: string;
  emailAddress: string;
  password: string;
  createdBy: string;
  dateOfBirth: Date;
  country: string;
  city: string;
  gender: string;
  interestedGender: string;
  status: string;
  dateModified: Date;
  mpin?: number,
  step: number
}
type Permission = {
  menuName: string,
  isEdit: number,
  isView: number
}

interface IUserState {
  userDetails: IUser | any;
  token: string;
  isAuthenticated: boolean,
  theme: "dark" | "light"
  permission: { [key: string]: Permission }

}

const initialState: IUserState = {
  userDetails: null,
  token: "",
  isAuthenticated: false,
  theme: "light",
  permission: null

};

const userSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    setUserData: (
      state,
      action: any
    ) => {
      state.userDetails = action.payload.data ?? state.userDetails;
      state.token = action.payload.token ?? state.token;
      state.isAuthenticated = true
      state.permission = convertPermissionToObject(action.payload?.data?.permissions)
    },
    purge: (state) => {
      state.userDetails = null
      state.token = "",
        state.isAuthenticated = false


    },
    setTheme: (state, action) => {
      state.theme = action.payload
    }

  },
});

export const { setUserData, purge, setTheme } = userSlice.actions;

export default userSlice.reducer;
